import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import LayoutContext from 'components/UI/Layout/LayoutContext';
import { get, isNumber } from 'lodash';
import themeHelpers from 'utils/theme-helpers';

const sizes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function Col({
    auto, children, className, lg, md, sm, xs, spacing, vSpacing,
})
{
    return (
        <LayoutContext.Consumer>
            {(containerProps) =>
            {
                const finalSpacing = isNumber(spacing) ? spacing : get(containerProps, 'spacing');

                const vSpacingValue = isNumber(vSpacing) ? vSpacing : get(containerProps, 'vSpacing');

                const finalVspacing = vSpacingValue === true ? finalSpacing : vSpacingValue;

                const classes = clsx({
                    'tw-flex-col': true,
                    [className]: true,
                    [`tw-px-${finalSpacing}`]: isNumber(finalSpacing) ? finalSpacing : false,
                    [`tw-my-${finalVspacing}`]: !!finalVspacing,
                    'tw-w-full': !xs && !sm && !md && !lg && !auto,
                    [lg === 12 ? 'lg:tw-w-full' : `${themeHelpers.column_sizes.lg[lg]}`]: !!lg,
                    [md === 12 ? 'md:tw-w-full' : `${themeHelpers.column_sizes.md[md]}`]: !!md,
                    [sm === 12 ? 'sm:tw-w-full' : `${themeHelpers.column_sizes.sm[sm]}`]: !!sm,
                    [xs === 12 ? 'tw-w-full' : `${themeHelpers.column_sizes.xs[xs]}`]: !!xs,

                });

                return (
                    <div className={classes}>
                        {children}
                    </div>
                );
            }}
        </LayoutContext.Consumer>
    );
}

Col.displayName = 'Col';

Col.defaultProps = {
    auto: false,
    className: '',
};

Col.propTypes = {
    auto: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    lg: PropTypes.oneOf(sizes),
    md: PropTypes.oneOf(sizes),
    sm: PropTypes.oneOf(sizes),
    spacing: PropTypes.number,
    vSpacing: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    xs: PropTypes.oneOf(sizes),
};

export default Col;
